import axiosInstance from '../../../config/axiosInstance';
const  SaleOrderService = {
    async GetAllSaleOrderNotes(redirectCallback,SaleOrderID) {
        try {            
           const ClientID=localStorage.getItem('CompanyID');
           const response = await axiosInstance.get(`/SaleOrder/GetSaleOrderNotes?SaleOrderID=${SaleOrderID}`);
           return response.data;
        } catch (error) {
           console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DeleteSaleOrderNotes(ID,redirectCallback) {
        try {
            const response = await axiosInstance.get(`/SaleOrder/DeleteSaleOrderNotes?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    }
};

export default SaleOrderService;